import React, { useState } from 'react';
import { 
    SubServiceItemContainer,
    SubServiceItemTitle,
    SubServiceItemIcon
} from './index.style'
import { Link } from 'gatsby'
import PropTypes from 'prop-types';
import IconArrowRight from '@svgs/IconArrowRight';

const SubServiceItem = ({item}) => {
    const { title, slug, parentService } = item;
    const [active, setActive] = useState();

    return (
        <SubServiceItemContainer>
            <Link to={`/what-we-do/${parentService.slug}/${slug}`} className="link">
                <SubServiceItemTitle>{title}</SubServiceItemTitle>
                <SubServiceItemIcon><IconArrowRight /></SubServiceItemIcon>
            </Link>
        </SubServiceItemContainer>
    );
};

SubServiceItem.propTypes = {
    item: PropTypes.object
};

export default SubServiceItem;